var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import { v4 as uuid } from 'uuid';
import { addNotification, closeNotification, clearNotifications } from '@bit/smartworks.unity.unity-core/unity-notifications-handler';
export default class UnityNotificationsHandler extends Component {
    constructor() {
        super(...arguments);
        this._notificationsHandlerRef = React.createRef();
        this.componentDidMount = () => {
            this.updateProperties();
        };
        this.componentDidUpdate = () => {
            this.updateProperties();
        };
        this.updateProperties = () => {
            const { props, _notificationsHandlerRef } = this;
            const unityNotificationsHandler = _notificationsHandlerRef.current;
            const { icons, colors, customTypes, allowDuplicates, noAnimation, onClose, target, position, } = props;
            if (!!unityNotificationsHandler) {
                if (!!icons)
                    unityNotificationsHandler.icons = icons;
                if (!!colors)
                    unityNotificationsHandler.colors = colors;
                if (!!customTypes)
                    unityNotificationsHandler.customTypes = customTypes;
                if (!!allowDuplicates)
                    unityNotificationsHandler.allowDuplicates = allowDuplicates;
                if (!!noAnimation)
                    unityNotificationsHandler.noAnimation = noAnimation;
                if (!!onClose)
                    unityNotificationsHandler.onClose = onClose;
                if (!!target)
                    unityNotificationsHandler.target = target;
                if (!!position)
                    unityNotificationsHandler.position = position;
            }
        };
    }
    render() {
        const _a = this, { _notificationsHandlerRef } = _a, _b = _a.props, _c = _b === void 0 ? {} : _b, { children = [], icons = {}, colors = {}, customTypes = {}, allowDuplicates = false, noAnimation = false, onClose = () => { } } = _c, other = __rest(_c, ["children", "icons", "colors", "customTypes", "allowDuplicates", "noAnimation", "onClose"]);
        if (!this.props.target) {
            console.warn(`UnityNotificationsHandler was not passed a "target" property.`);
            return (React.createElement(React.Fragment, null, children));
        }
        const otherProps = Object.assign({}, other);
        if (allowDuplicates)
            otherProps.allowDuplicates = allowDuplicates;
        if (noAnimation)
            otherProps.noAnimation = noAnimation;
        return (React.createElement("unity-notifications-handler", Object.assign({ ref: _notificationsHandlerRef }, otherProps), children));
    }
}
export function withNotifications(handlerProps) {
    return function wrapComponent(WrappedComponent) {
        return (props) => {
            const { target, position, icons, colors, customTypes, allowDuplicates, noAnimation, onClose, style = {} } = handlerProps || {};
            const _uniqueName = target || uuid();
            const _notificationsHandlerRef = React.createRef();
            const { current: notificationsHandler = null } = _notificationsHandlerRef || {};
            if (!!notificationsHandler) {
                if (!!icons)
                    notificationsHandler.icons = icons;
                if (!!colors)
                    notificationsHandler.colors = colors;
                if (!!customTypes)
                    notificationsHandler.customTypes = customTypes;
                if (!!allowDuplicates)
                    notificationsHandler.allowDuplicates = allowDuplicates;
                if (!!noAnimation)
                    notificationsHandler.noAnimation = noAnimation;
                if (!!onClose)
                    notificationsHandler.onClose = onClose;
            }
            return (React.createElement("unity-notifications-handler", { target: _uniqueName, position: position, ref: _notificationsHandlerRef, style: style },
                React.createElement(WrappedComponent, Object.assign({ addNotification: ({ target = _uniqueName, notification }) => addNotification({ target, notification }), closeNotification: (target = _uniqueName) => closeNotification(target), clearNotifications: (target = _uniqueName) => clearNotifications(target) }, props))));
        };
    };
}
export { addNotification, closeNotification, clearNotifications };
export { default as UnityNotificationsModal } from './UnityNotificationsModal';
export * from './UnityNotificationsModal';
export { default as UnityNotificationsSplitPane } from './UnityNotificationsSplitPane';
export * from './UnityNotificationsSplitPane';
